import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { isDisableInviteTeamMember } from '@disco/state-management/selectors/invites'
import {
  getCorePlan,
  isBankDraftSubscriber,
} from '@disco/state-management/selectors/user'
import Alert from 'components/ui/alert'
import ContactUsLink from 'components/ui/contact-us-link'

const LegacyPlansAlert = (): null | React.ReactNode => {
  const corePlan = useSelector(getCorePlan)
  const disableInviteTeamMember = useSelector(isDisableInviteTeamMember)
  const bankDraftSubscriber = useSelector(isBankDraftSubscriber)
  if (!disableInviteTeamMember) return null
  // legacy plan
  let alertContent = (
    <>
      You’re on a legacy plan. To add more users or tracks you’ll need to update
      your plan. View pricing options{' '}
      <a
        className="text-link"
        href="https://disco.ac/pricing"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>
      , and to upgrade{' '}
      <ContactUsLink
        intercomMsg="I'd like to change plan"
        className="text-link"
      >
        contact support.
      </ContactUsLink>
    </>
  )

  // lite plan
  if (corePlan?.id === '2020-lite') {
    alertContent = (
      <>
        Your Lite plan has a limit of 1 user and 500 tracks. To add more users
        or tracks you’ll need to upgrade your plan. View pricing options{' '}
        <a
          className="text-link"
          href="https://disco.ac/pricing"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        , and to upgrade{' '}
        <ContactUsLink
          intercomMsg="I'd like to change plan"
          className="text-link"
        >
          contact support.
        </ContactUsLink>
      </>
    )
  }

  // bank draft
  if (bankDraftSubscriber) {
    alertContent = (
      <>
        Your account pays via bank draft. To add more users or tracks you’ll
        need to{' '}
        <ContactUsLink
          intercomMsg="I'd like to change plan"
          className="text-link"
        >
          contact sales.
        </ContactUsLink>
      </>
    )
  }

  return (
    <Alert status="warning" icon="warning">
      {alertContent}
    </Alert>
  )
}

export default LegacyPlansAlert
